export const PATHS = {
  AUDIO: {
    BASE: 'https://om-assets.fra1.cdn.digitaloceanspaces.com/assets/audio',
    BACKGROUND_MUSIC: 'https://om-assets.fra1.cdn.digitaloceanspaces.com/assets/audio/background_music',
    BOOKS: {
      wolves_of_langston: {
        id: 'wolves_of_langston',
        hasAudio: true,
        path: 'wolves_of_langston',
        pathFormat: {
          male: '', // No suffix for male voice
          female: '_female', // Suffix for female voice
          Johan: '', // No suffix for Johan voice (same as male)
          Lisbeth: '_female' // Suffix for Lisbeth voice (same as female for backward compatibility)
        },
        usesNewNaming: false // Explicitly mark as using old naming
      },
      pantry: {
        id: 'pantry',
        hasAudio: true,
        path: 'pantry',
        pathFormat: {
          male: '_male',
          female: '_female',
          Johan: '_Johan',
          Lisbeth: '_Lisbeth'
        },
        usesNewNaming: false // Flag to indicate this book uses the new naming convention
      },
      ser_laurens_cursed_cycle: {
        id: 'ser_laurens_cursed_cycle',
        hasAudio: true,
        path: 'ser_laurens_cursed_cycle',
        pathFormat: {
          male: '_male',
          female: '_female',
          Johan: '_Johan',
          Lisbeth: '_Lisbeth'
        },
        usesNewNaming: false // Flag to indicate this book uses the new naming convention
      },
      gritz_manor: {
        id: 'gritz_manor',
        hasAudio: true,
        path: 'gritz_manor',
        pathFormat: {
          male: '_male',
          female: '_female',
          Johan: '_Johan',
          Lisbeth: '_Lisbeth'
        },
        usesNewNaming: false // Flag to indicate this book uses the new naming convention
      }
    }
  },
  BOOKS: {
    BASE: 'https://om-assets.fra1.cdn.digitaloceanspaces.com/assets/json',
    DATA: {
      wolves_of_langston: 'wolves_of_langston.json',
      pantry: 'pantry.json',
      ser_laurens_cursed_cycle:'ser_laurens_cursed_cycle.json',
      gritz_manor:'gritz_manor.json'
    }
  }
};

export const DEFAULT_SETTINGS = {
  FONT_SIZE: 17,
  BACKGROUND_MUSIC_VOLUME: 0.05,
  VOICE_VOLUME: 0.05,
  PLAYBACK_RATE: 1.0
};

export const STORAGE_KEYS = {
  VOICE_PREFERENCE: 'voicePreference',
  AUTOPLAY_PREF: 'autoplayPref',
  STORY_STATE: 'storyState',
  PLAYBACK_RATE: 'playbackRate'
};

// Map old voice names to new voice names for compatibility
export const VOICE_NAME_MAPPING = {
  // For new books: map old names to new names
  male: 'Johan',
  female: 'Lisbeth',
  
  // For old books: map new names to old names
  Johan: 'male',
  Lisbeth: 'female'
}; 

